'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondsFromNow.js
// module id = 702
// module chunks = 0